import Loader from './core'

export default Loader
